import { observer } from 'mobx-react-lite';
import ShoppingValuesSection from '@features/productPreview/sections/UniversalShoppingValues/ShoppingValuesSection';
import ProductDescription from '@features/productPreview/sections/ProductDescription/ProductDescription';
import { ISection } from '@features/productPreview/typescript';
import { WindowType } from '@typescript/index';
import AboutCollection from '@features/productPreview/sections/AboutCollection/AboutCollection';
import { productPageState } from '@features/productPreview/mobX/state/context';
import GallerySection from '@features/productPreview/sections/Gallery/GallerySection';
const Empty = () => null;
const sectionComponent = {
  PRODUCT_SLIDES: GallerySection,
  PRODUCT_DESCRIPTIONS: ProductDescription,
  COLLECTION_VIDEO: AboutCollection,
  PRODUCT_PROMOTIONAL: ShoppingValuesSection,
  DEFAULT: ProductDescription
};
type SectionPropsType = {
  section: ISection;
  windowType: WindowType;
  typeofconfigurator?: 'front' | 'basic' | 'old';
  isCreativeProduct?: boolean;
};
const Section = ({
  section,
  windowType,
  typeofconfigurator,
  isCreativeProduct
}: SectionPropsType) => {
  const state = productPageState;
  const SpecificSection = sectionComponent[section.type] || Empty;
  return <SpecificSection section={section} windowType={windowType} state={state} typeofconfigurator={typeofconfigurator} isCreativeProduct={isCreativeProduct} />;
};
export default observer(Section);